<template>
    <tr :class="{'red_txt': isCanceled, 'lgray_txt': isRemoved}" @dblclick="action_DoubleClick">
        <td :title="nameFull">
            <span class="ellipsis">{{ name }}</span>
        </td>
        <td :title="groupTitleFull">
            <span class="ellipsis">{{ groupTitle }}</span>
        </td>
        <td :title="columnTitle">
            <span class="ellipsis">{{ columnTitle }}</span>
        </td>
        <td>
            <span class="">{{ reservationDateString }}</span>
        </td>
        <td :title="programTitleFull">
            <span class="ellipsis">{{ programTitle }}</span>
        </td>
        <td style="word-break: break-all;">
            <span class="">{{ type }}</span>
        </td>
        <td :title="modifierNameFull">
            <span class="ellipsis">{{ modifierName }}</span>
        </td>
        <td>
            <span class="">{{ modifiedAt }}</span>
        </td>
    </tr>
</template>


<script>
import { closeReservationHistoryPopup } from '../../../sheet-overlays'
import { setSelectedReservation } from '../../../reservation-selection'
import { setSelectedDate } from '../../../sheet-axis'
import { useQueryClient } from '@tanstack/vue-query'
import { isApiErrorWithCode } from '@/apis/instances/check-api-response'
import { v2ReservationListQueryOptions } from '@/composables/queries/v2reservation/use-v2-reservation-list-query'

const moment = require('@/util/MPMoment')
export default {
    setup() {
        const queryClient = useQueryClient()
        return { queryClient }
    },
    props: {
        history: Object,
    },
    data() {
        return {
        }
    },
    computed: {
        nameFull: function () {
            return this.history.body?.userName
        },
        name: function () {
            if ((this.nameFull?.length ?? 0) > 20) {
                return this.nameFull?.substring(0, 20) + '...'
            }
            return this.nameFull
        },
        groupTitleFull: function () {
            return this.history.body?.groupTitle
        },
        groupTitle: function () {
            if ((this.groupTitleFull?.length ?? 0) > 20) {
                return this.groupTitleFull?.substring(0, 20) + '...'
            }
            return this.groupTitleFull
        },
        columnTitleFull: function () {
            return this.history.body?.columnTitle
        },
        columnTitle: function () {
            if ((this.columnTitleFull?.length ?? 0) > 20) {
                return this.columnTitleFull?.substring(0, 20) + '...'
            }
            return this.columnTitleFull
        },
        reservationDateString: function () {
            return moment(this.history.body.startedAt).format(this.$t('common.date_format_YYYY_MM_DD_HH_mm'))
        },
        programTitleFull: function () {
            return this.history.body.programTitle
        },
        programTitle: function () {
            return this.programTitleFull?.substring(0, 20)
        },
        type: function () {
            if (this.history.key == 'create') { return this.$t('popup_reservation_history.label_action_status_registered') }
            if (this.history.key == 'update') { return this.$t('popup_reservation_history.label_action_status_edited') }
            if (this.history.key == 'remove') { return this.$t('popup_reservation_history.label_action_status_deleted') }
            return this.$t('popup_reservation_history.label_action_status_canceled')
        },
        modifierNameFull: function () {
            if (this.history.writerID?.type >= 3000) {
                return '애프터닥'
            } else if (this.history.writerID?.type <= 1000) {
                return '고객'
            } else {
                return this.history.writerID?.realName
            }
        },
        modifierName: function () {
            if ((this.modifierNameFull.length ?? 0) > 20) {
                return this.modifierNameFull.slice(0, 20) + '...'
            }
            return this.modifierNameFull
        },
        modifiedAt: function () {
            return moment(this.history.createdAt).format(this.$t('common.date_format_YYYY_MM_DD_HH_mm'))
        },
        isCanceled: function () {
            return this.type == '취소'
        },
        isRemoved: function () {
            return this.type == '삭제'
        },
    },
    methods: {
        async action_DoubleClick() {
            if (this.type == '삭제') { return }
            let model = {
                _id: this.history.reservationID,
            }
            let reservations
            try {
                reservations = await this.queryClient.fetchQuery(v2ReservationListQueryOptions(model))
            } catch (err) {
                // 기존 동작 미러링: 봉투 code != 0 이면 로그만 남기고 중단
                if (!isApiErrorWithCode(err)) throw err
                console.log(err)
                return
            }
            let reservation = reservations[0]
            let selectedDate = moment(reservation.startedAt).startOf('days')
            setSelectedReservation(reservation)
            setSelectedDate(selectedDate)
            closeReservationHistoryPopup()
        }
    }
}
</script>